
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("hD0Hb", function(module, exports) {
/* PageTreeMacroRenderer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $gdv5Z = parcelRequire("gdv5Z");


var $u9agA = parcelRequire("u9agA");


var $fVUfS = parcelRequire("fVUfS");


var $eyWa4 = parcelRequire("eyWa4");


var $iXCQx = parcelRequire("iXCQx");


var $9hlns = parcelRequire("9hlns");


var $4noo5 = parcelRequire("4noo5");


var $ccHMk = parcelRequire("ccHMk");


var $fzqvY = parcelRequire("fzqvY");


var $1NBp8 = parcelRequire("1NBp8");


var $e4o8D = parcelRequire("e4o8D");


var $eCryJ = parcelRequire("eCryJ");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $5kjCz = parcelRequire("5kjCz");


var $JbVPK = parcelRequire("JbVPK");


var $bX5uj = parcelRequire("bX5uj");





var $jMyy4 = parcelRequire("jMyy4");


var $bEk7g = parcelRequire("bEk7g");


var $eDO9L = parcelRequire("eDO9L");


var $6SH28 = parcelRequire("6SH28");


var $49vfa = parcelRequire("49vfa");


var $gzvFl = parcelRequire("gzvFl");


var $jvHsR = parcelRequire("jvHsR");

// ---------------------------------------------------------------------------
// Helpers
// ---------------------------------------------------------------------------
const $120689156450f914$var$extractRootLevelNodes = (data, sort, reverse)=>{
    const firstPage = data?.ptpage;
    if (!firstPage) return null;
    const rawPages = [
        firstPage
    ];
    const siblings = firstPage.followingSiblings?.nodes;
    if (siblings) {
        for (const s of siblings)if (s) rawPages.push(s);
    }
    return (0, $bEk7g.sortNodes)(rawPages.map((0, $bEk7g.mapPtPageNode)), sort, reverse);
};
const $120689156450f914$var$extractAncestorIds = (data)=>{
    const ancestors = data?.ptpage?.nearestAncestors?.nodes;
    if (!ancestors) return [];
    const ids = [];
    for (const a of ancestors)if (a?.id) ids.push(a.id);
    return ids;
};
const $120689156450f914$export$b005fb2b94547bd6 = ({ contentId: contentId, rootParam: rootParam, spaceKey: spaceKey, sort: sort, reverse: reverse })=>{
    const rootType = (0, $bEk7g.parseRootType)(rootParam);
    const pageTitle = rootType === 'title' && rootParam ? (0, $bEk7g.parsePageTitle)(rootParam) : undefined;
    // Build CQL for title search (stable across renders)
    const cql = (0, $42omo.useMemo)(()=>rootType === 'title' && pageTitle ? (0, $bEk7g.buildTitleSearchCql)(pageTitle, spaceKey) : '', [
        rootType,
        pageTitle,
        spaceKey
    ]);
    // --- Step 1: Root resolution queries (only one runs based on rootType) ---
    const homepageResult = (0, $jMyy4.useQueryInterop)((0, $49vfa.default), {
        variables: {
            spaceKey: spaceKey
        },
        skip: rootType !== 'home',
        __callerPackage__: "@confluence/pagetree-macro"
    });
    const parentAncestorResult = (0, $jMyy4.useQueryInterop)((0, $6SH28.default), {
        variables: {
            contentId: contentId
        },
        skip: rootType !== 'parent',
        __callerPackage__: "@confluence/pagetree-macro"
    });
    const searchResult = (0, $jMyy4.useQueryInterop)((0, $jvHsR.default), {
        variables: {
            cql: cql
        },
        skip: rootType !== 'title' || !pageTitle,
        __callerPackage__: "@confluence/pagetree-macro"
    });
    const rootLevelResult = (0, $jMyy4.useQueryInterop)((0, $gzvFl.default), {
        variables: {
            spaceKey: spaceKey
        },
        skip: rootType !== 'none',
        __callerPackage__: "@confluence/pagetree-macro"
    });
    // Derive rootId from whichever query ran
    const rootId = (0, $bEk7g.resolveRootId)({
        rootType: rootType,
        contentId: contentId,
        homepageData: homepageResult.data,
        ancestorData: parentAncestorResult.data,
        searchData: searchResult.data
    });
    // `@none` lists top-level pages with no specific root, so it can never be
    // "not found". For every other root type — including `@self`, whose rootId
    // is the current page (contentId) — resolution succeeds only when a rootId
    // was derived. Mirrors the legacy backend's `!noRoot && rootPage == null`.
    const rootResolved = rootType === 'none' || rootId != null;
    // --- Step 2: Fetch root's children (depends on rootId) ---
    const childrenResult = (0, $jMyy4.useQueryInterop)((0, $eDO9L.default), {
        variables: {
            contentId: rootId ?? '',
            first: (0, $bEk7g.CHILDREN_PAGE_SIZE),
            after: null
        },
        skip: !rootId || !(0, $bEk7g.needsRootChildren)(rootType),
        __callerPackage__: "@confluence/pagetree-macro"
    });
    // --- Step 3: Fetch ancestors for auto-expansion ---
    const ancestorsResult = (0, $jMyy4.useQueryInterop)((0, $6SH28.default), {
        variables: {
            contentId: contentId
        },
        skip: !(0, $bEk7g.needsAncestorExpansion)(rootType),
        __callerPackage__: "@confluence/pagetree-macro"
    });
    // --- Derive final state ---
    // Skipped queries return loading: false, so only active queries contribute
    const loading = homepageResult.loading || parentAncestorResult.loading || searchResult.loading || rootLevelResult.loading || childrenResult.loading;
    const error = homepageResult.error?.message ?? parentAncestorResult.error?.message ?? searchResult.error?.message ?? rootLevelResult.error?.message ?? childrenResult.error?.message ?? ancestorsResult.error?.message ?? null;
    const nodes = (0, $42omo.useMemo)(()=>{
        if (loading) return null;
        if (rootType === 'none') return $120689156450f914$var$extractRootLevelNodes(rootLevelResult.data, sort, reverse);
        if (!rootId) return null;
        return (0, $bEk7g.extractChildNodes)(childrenResult.data, sort, reverse);
    }, [
        loading,
        rootType,
        rootId,
        rootLevelResult.data,
        childrenResult.data,
        sort,
        reverse
    ]);
    const ancestorIds = (0, $42omo.useMemo)(()=>{
        if (!(0, $bEk7g.needsAncestorExpansion)(rootType)) return [];
        const allAncestors = $120689156450f914$var$extractAncestorIds(ancestorsResult.data);
        if (rootType === 'none') return allAncestors;
        if (!rootId) return [];
        const rootIndex = allAncestors.indexOf(rootId);
        if (rootIndex >= 0) return allAncestors.slice(0, rootIndex + 1);
        return [];
    }, [
        rootType,
        rootId,
        ancestorsResult.data
    ]);
    return {
        nodes: nodes,
        ancestorIds: ancestorIds,
        loading: loading,
        error: error,
        rootResolved: rootResolved,
        rootId: rootId
    };
};





/* PageTreeNode.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $auNCB = parcelRequire("auNCB");




















var $6R5uz = parcelRequire("6R5uz");


var $ghftu = parcelRequire("ghftu");





var $dF6Hu = parcelRequire("dF6Hu");







const $fb81ff3196c114be$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    error: {
        id: "pagetree-macro.renderer.error",
        defaultMessage: "There was a problem retrieving the page tree. Please check the server log file for more information."
    },
    rootNotFound: {
        id: "pagetree-macro.renderer.root-not-found",
        defaultMessage: "The selected root page could not be found."
    },
    unsupportedContent: {
        id: "pagetree-macro.renderer.unsupported-content",
        defaultMessage: "Page Tree can only be used in pages, blog posts and comments."
    },
    permissionError: {
        id: "pagetree-macro.renderer.permission-error",
        defaultMessage: "Unable to load page tree. It seems that you do not have permission to view the root page."
    },
    expandAll: {
        id: "pagetree-macro.renderer.expand-all",
        defaultMessage: "Expand all"
    },
    collapseAll: {
        id: "pagetree-macro.renderer.collapse-all",
        defaultMessage: "Collapse all"
    },
    searchPlaceholder: {
        id: "pagetree-macro.renderer.search-placeholder",
        defaultMessage: "Search page tree"
    },
    searchButton: {
        id: "pagetree-macro.renderer.search-button",
        defaultMessage: "Search"
    },
    loading: {
        id: "pagetree-macro.renderer.loading",
        defaultMessage: "Loading..."
    }
});






var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");







const $0a974122c78942c7$export$94bab3bded73e53e = (0, $3u0dr.isReactCompilerActiveV2)() ? (query, options)=>{
    const $ = (0, $frIzR.c)(4);
    let t0;
    if ($[0] !== options) {
        t0 = {
            ...options,
            skip: true
        };
        $[0] = options;
        $[1] = t0;
    } else t0 = $[1];
    const { refetch: refetch } = (0, $jMyy4.useQueryInterop)(query, t0);
    let t1;
    if ($[2] !== refetch) {
        t1 = (variables)=>refetch(variables);
        $[2] = refetch;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : (query, options)=>{
    const { refetch: refetch } = (0, $jMyy4.useQueryInterop)(query, {
        ...options,
        skip: true
    });
    return (0, $42omo.useCallback)((variables)=>refetch(variables), [
        refetch
    ]);
};








const $45f3f848bb214fac$export$76f558d5e8bc4316 = (sort, reverse)=>{
    const refetchChildren = (0, $0a974122c78942c7$export$94bab3bded73e53e)((0, $eDO9L.default));
    return (0, $42omo.useCallback)((parentId)=>{
        return (0, $bEk7g.extractChildren)(refetchChildren, parentId, sort, reverse);
    }, [
        refetchChildren,
        sort,
        reverse
    ]);
};





/**
 * @generated SignedSource<<07b9499f74a0c31c181e0685d15fe8e0>>
 * @relayHash 52013f0873cfb55c65dc863935d18fe5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID cbde4e508d29770e80a55d02198aad11082b6e45226b9cd72314d0ee9f5f64d7
const $b6228c9741b5c434$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
        }
    ], v2 = {
        "concreteType": "ConfluenceMacroExcerptBody",
        "kind": "LinkedField",
        "name": "macroExcerpt",
        "plural": false,
        "selections": [
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "fallbackToBody",
                        "value": false
                    }
                ],
                "kind": "ScalarField",
                "name": "atlasDocFormat",
                "storageKey": "atlasDocFormat(fallbackToBody:false)"
            }
        ]
    }, v3 = {
        "concreteType": "ContentBodyPerRepresentation",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": [
            {
                "concreteType": "ContentBody",
                "kind": "LinkedField",
                "name": "atlas_doc_format",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "EmbeddedMediaToken",
                        "kind": "LinkedField",
                        "name": "mediaToken",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "token"
                            }
                        ]
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "PageTreeMacroExcerptQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "PageTreeMacroExcerptQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "52013f0873cfb55c65dc863935d18fe5",
            "id": "cbde4e508d29770e80a55d02198aad11082b6e45226b9cd72314d0ee9f5f64d7",
            "metadata": {},
            "name": "PageTreeMacroExcerptQuery",
            "operationKind": "query",
            "text": "query PageTreeMacroExcerptQuery($id:ID!){content(id:$id){nodes{macroExcerpt{atlasDocFormat(fallbackToBody:false)},body{atlas_doc_format{mediaToken{token}}},id}}}"
        }
    };
}();
$b6228c9741b5c434$var$node.hash = "e9b6f3a3e542e69f0e195cee46734cf8";
var $b6228c9741b5c434$export$2e2bcd8739ae039 = $b6228c9741b5c434$var$node;


const $ea36937e8193af66$var$styles = {
    nodeContainer: "_1rjcv77o",
    childrenContainer: "_bozgpxbi",
    nodeLabel: "_1e0c1txw _4cvr1y6m",
    toggleButton: "_1yt4ze3t _1dqoglyw _1bsb1crf _4t3i1tcg _1e0c116y _1bah1h6o _4cvr1h6o _1o9zidpf _80omtlke _bfhk1j28",
    toggleContainerLeaf: "_1bsb1crf _4t3i1tcg _1e0c116y _1bah1h6o _4cvr1h6o _1o9zidpf",
    dot: "_2rko1rr0 _1bsb1y44 _4t3i1y44 _bfhk1gdz",
    link: "_4bfu1r31 _1hmsglyw _ajmmnqa1",
    boldLink: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _k48pwu06",
    titleColumn: "_1e0c1txw _2lx21bp4 _1ul9idpf",
    excerptWrapper: "_11c8wadc _syaz1rpy _bozgu2gc"
};
const $ea36937e8193af66$var$PageTreeNodeComponentImpl = ({ node: node, showExcerpt: showExcerpt, startDepth: startDepth, currentDepth: currentDepth, currentPageId: currentPageId, spaceKey: spaceKey, spaceId: spaceId, sort: sort, reverse: reverse, ancestorIds: ancestorIds, RendererWrapper: RendererWrapper, excerptMap: excerptMap, enqueueExcerptIds: enqueueExcerptIds, loadedViaAutoExpand: loadedViaAutoExpand })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const loadChildren = (0, $45f3f848bb214fac$export$76f558d5e8bc4316)(sort, reverse);
    const isAncestor = ancestorIds.includes(node.id);
    const isCurrentPage = node.id === currentPageId;
    const shouldAutoExpand = startDepth - currentDepth > 1 || isAncestor; // SSR-compatible: read preloaded children from cache for auto-expanding nodes
    const needsAutoExpandChildren = shouldAutoExpand && node.hasChildren && !node.children?.length;
    const autoExpandResult = (0, $jMyy4.useQueryInterop)((0, $eDO9L.default), {
        variables: {
            contentId: node.id,
            first: (0, $bEk7g.CHILDREN_PAGE_SIZE),
            after: null
        },
        skip: !needsAutoExpandChildren,
        __callerPackage__: "@confluence/pagetree-macro"
    });
    const autoExpandChildren = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>(0, $bEk7g.extractChildNodes)(autoExpandResult.data, sort, reverse) ?? [], [
        autoExpandResult.data,
        sort,
        reverse
    ]); // Feed auto-expanded children IDs into the batch loader so the next batch
    // picks them up. This is the fix for the original coverage gap:
    // previously only the visible root IDs were batched, and every
    // auto-expanded child fell through to a per-node ExcerptQuery (N+1).
    (0, $42omo.useEffect)(()=>{
        if (!showExcerpt || autoExpandChildren.length === 0) return;
        enqueueExcerptIds(autoExpandChildren.map((c)=>c.id));
    }, [
        showExcerpt,
        autoExpandChildren,
        enqueueExcerptIds
    ]); // Read *this* node's entry from the batch result map. Undefined means
    // "not yet resolved by the batch loader" -- the per-node fallback below
    // is gated on `loadedViaAutoExpand` so it only fires for manual chevron
    // expansions, not for the race window before the batch lands.
    const entry = excerptMap.get(node.id);
    const storeAdfString = entry?.adfString;
    const storeMediaToken = entry?.mediaToken; // Per-node fallback only fires when this node was loaded by the user
    // clicking the chevron (i.e. NOT auto-expanded). Auto-expanded nodes are
    // always served from the batch loader; the gate is the prop, not the map
    // state -- otherwise children mount before the renderer's `enqueueExcerptIds`
    // effect runs and fire individual queries against the same IDs the batch
    // is about to fetch.
    const needsIndividualFetch = showExcerpt && !loadedViaAutoExpand;
    const individualResult = (0, $jMyy4.useQueryInterop)((0, $b6228c9741b5c434$export$2e2bcd8739ae039), {
        variables: {
            id: node.id
        },
        skip: !needsIndividualFetch,
        __callerPackage__: "@confluence/pagetree-macro"
    });
    const excerptAdfString = storeAdfString ?? (0, $bEk7g.extractSingleNodeAdfString)(individualResult.data);
    const excerptMediaToken = storeMediaToken ?? (0, $bEk7g.extractSingleNodeMediaToken)(individualResult.data);
    const excerptAdfDocument = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>excerptAdfString ? (0, $dF6Hu.parseNestedAdfDocument)(excerptAdfString) : null, [
        excerptAdfString
    ]);
    const hasExcerpt = showExcerpt && excerptAdfDocument != null && excerptAdfDocument.content.length > 0;
    const [state, setState] = (0, $42omo.useState)({
        isExpanded: shouldAutoExpand,
        children: node.children ?? [],
        isLoading: false,
        childrenLoaded: !!node.children?.length
    }); // Merge: use auto-expand query result if state doesn't have children yet
    const resolvedChildren = state.childrenLoaded ? state.children : autoExpandChildren;
    const resolvedChildrenLoaded = state.childrenLoaded || autoExpandChildren.length > 0;
    const resolvedLoading = state.isLoading || needsAutoExpandChildren && autoExpandResult.loading; // Children rendered out of `state.children` were loaded by a manual chevron
    // click; children rendered out of `autoExpandChildren` came in via the
    // auto-expand query and so should keep using the batch store for excerpts.
    const childrenLoadedViaAutoExpand = !state.childrenLoaded;
    const handleToggle = (0, $42omo.useCallback)(async ()=>{
        if (state.isExpanded) {
            setState((prev)=>({
                    ...prev,
                    isExpanded: false
                }));
            return;
        }
        if (!resolvedChildrenLoaded && node.hasChildren) {
            setState((prev)=>({
                    ...prev,
                    isLoading: true
                }));
            const loadedChildren = await loadChildren(node.id);
            setState((prev)=>({
                    ...prev,
                    children: loadedChildren,
                    childrenLoaded: true,
                    isExpanded: true,
                    isLoading: false
                }));
        } else setState((prev)=>({
                ...prev,
                isExpanded: true
            }));
    }, [
        state.isExpanded,
        resolvedChildrenLoaded,
        node.hasChildren,
        node.id,
        loadChildren
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $ea36937e8193af66$var$styles.nodeContainer,
        testId: `pagetree-node-${node.id}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $ea36937e8193af66$var$styles.nodeLabel
    }, node.hasChildren ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVUfS.default), {
        xcss: $ea36937e8193af66$var$styles.toggleButton,
        onClick: handleToggle,
        "aria-expanded": state.isExpanded,
        "aria-label": state.isExpanded ? `Collapse ${node.title}` : `Expand ${node.title}`,
        testId: `pagetree-toggle-${node.id}`
    }, state.isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
        label: "",
        color: "var(--ds-text-subtlest, #6B6E76)",
        size: "small",
        spacing: "none"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))), {
        label: "",
        color: "var(--ds-text-subtlest, #6B6E76)",
        size: "small",
        spacing: "none"
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $ea36937e8193af66$var$styles.toggleContainerLeaf
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $ea36937e8193af66$var$styles.dot
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $ea36937e8193af66$var$styles.titleColumn
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $auNCB.default), {
        href: node.url,
        testId: `pagetree-link-${node.id}`,
        xcss: isCurrentPage ? $ea36937e8193af66$var$styles.boldLink : $ea36937e8193af66$var$styles.link
    }, node.title), hasExcerpt && excerptAdfDocument && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $ea36937e8193af66$var$styles.excerptWrapper,
        testId: `pagetree-excerpt-${node.id}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(RendererWrapper, {
        adf: excerptAdfDocument.content,
        targetContentId: node.id,
        targetSpaceKey: spaceKey,
        targetSpaceId: spaceId,
        mediaToken: excerptMediaToken
    })))), resolvedLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $ea36937e8193af66$var$styles.childrenContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        alignBlock: "center",
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, formatMessage((0, $fb81ff3196c114be$export$a7357cdd1f0b0168).loading)))), state.isExpanded && !resolvedLoading && resolvedChildren.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        xcss: $ea36937e8193af66$var$styles.childrenContainer,
        testId: `pagetree-children-${node.id}`
    }, resolvedChildren.map((child)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ea36937e8193af66$export$8f2e502782521c88, {
            key: child.id,
            node: child,
            showExcerpt: showExcerpt,
            startDepth: startDepth,
            currentDepth: currentDepth + 1,
            currentPageId: currentPageId,
            spaceKey: spaceKey,
            spaceId: spaceId,
            sort: sort,
            reverse: reverse,
            ancestorIds: ancestorIds,
            RendererWrapper: RendererWrapper,
            excerptMap: excerptMap,
            enqueueExcerptIds: enqueueExcerptIds,
            loadedViaAutoExpand: childrenLoadedViaAutoExpand
        }))));
};
const $ea36937e8193af66$export$8f2e502782521c88 = $ea36937e8193af66$var$PageTreeNodeComponentImpl;












/**
 * @generated SignedSource<<3ab63b42ad0fe21c488994dfd731cacf>>
 * @relayHash 9f966c5ad5bb58793dc9d476443332d3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7cc5278a5c190b32f2f1d8e09ad7251d584ba4e49ceb47d7c4ca39c035b0e8b6
const $ffc2f0f2f9bab974$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "ids"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "after",
                    "variableName": "after"
                },
                {
                    "kind": "Variable",
                    "name": "first",
                    "variableName": "first"
                },
                {
                    "kind": "Variable",
                    "name": "ids",
                    "variableName": "ids"
                },
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": "page"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "count"
                },
                {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "hasNextPage"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "endCursor"
                        }
                    ]
                },
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "concreteType": "ConfluenceMacroExcerptBody",
                            "kind": "LinkedField",
                            "name": "macroExcerpt",
                            "plural": false,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "fallbackToBody",
                                            "value": false
                                        }
                                    ],
                                    "kind": "ScalarField",
                                    "name": "atlasDocFormat",
                                    "storageKey": "atlasDocFormat(fallbackToBody:false)"
                                }
                            ]
                        },
                        {
                            "concreteType": "ContentBodyPerRepresentation",
                            "kind": "LinkedField",
                            "name": "body",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentBody",
                                    "kind": "LinkedField",
                                    "name": "atlas_doc_format",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "EmbeddedMediaToken",
                                            "kind": "LinkedField",
                                            "name": "mediaToken",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "token"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "PageTreeMacroExcerptBatchQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "PageTreeMacroExcerptBatchQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "9f966c5ad5bb58793dc9d476443332d3",
            "id": "7cc5278a5c190b32f2f1d8e09ad7251d584ba4e49ceb47d7c4ca39c035b0e8b6",
            "metadata": {},
            "name": "PageTreeMacroExcerptBatchQuery",
            "operationKind": "query",
            "text": "query PageTreeMacroExcerptBatchQuery($ids:[ID!]!,$first:Int!,$after:String){content(ids:$ids,first:$first,after:$after,type:\"page\"){count,pageInfo{hasNextPage,endCursor},nodes{id,macroExcerpt{atlasDocFormat(fallbackToBody:false)},body{atlas_doc_format{mediaToken{token}}}}}}"
        }
    };
}();
$ffc2f0f2f9bab974$var$node.hash = "b191180b54dd635cfaede7c7980cc5e4";
var $ffc2f0f2f9bab974$export$2e2bcd8739ae039 = $ffc2f0f2f9bab974$var$node;


/** Server-side cap for `content(ids:)` and aligned cursor page size. */ const $6637ea4439045177$var$EXCERPT_BATCH_LIMIT = 25;
const $6637ea4439045177$var$INITIAL_STATE = {
    excerptMap: new Map(),
    currentRequest: null
};
/** Stable variables passed to `useQueryInterop` while skipped. */ const $6637ea4439045177$var$SKIP_VARIABLES = {
    ids: [],
    first: $6637ea4439045177$var$EXCERPT_BATCH_LIMIT,
    after: null
};
/**
 * Build a Map containing the previous entries plus newly-resolved nodes.
 * Extracted into a separate function so the per-node loop is not lexically
 * nested inside the per-page loop in the post-fetch effect -- the
 * `@atlassian/perf-linting/no-quadratic-complexity` rule flags nested
 * iteration even when the inner loop is bounded.
 */ const $6637ea4439045177$var$mergeBatchPage = (prev, nodes)=>{
    const next = new Map(prev);
    for (const node of nodes){
        if (!node.id) continue;
        next.set(node.id, {
            adfString: node.adfString,
            mediaToken: node.mediaToken
        });
    }
    return next;
};
const $6637ea4439045177$export$33e885d6fee42b92 = (showExcerpt)=>{
    const [state, setState] = (0, $42omo.useState)($6637ea4439045177$var$INITIAL_STATE);
    // Pending IDs queued for the next chunk. Mutated synchronously by
    // `enqueueExcerptIds`; consumed when a chunk completes (or when the loader is
    // idle and a new request comes in).
    const pendingQueueRef = (0, $42omo.useRef)([]);
    // IDs we've ever queued. Used to dedup so the same ID never makes it
    // into two batches.
    const seenIdsRef = (0, $42omo.useRef)(new Set());
    // Tracks which response object we've already processed so the post-fetch
    // effect doesn't re-process the same data on unrelated renders.
    const processedDataRef = (0, $42omo.useRef)(undefined);
    const variables = (0, $42omo.useMemo)(()=>state.currentRequest ? {
            ids: state.currentRequest.ids,
            first: $6637ea4439045177$var$EXCERPT_BATCH_LIMIT,
            after: state.currentRequest.after
        } : $6637ea4439045177$var$SKIP_VARIABLES, [
        state.currentRequest
    ]);
    const takeNextRequest = (0, $42omo.useCallback)(()=>{
        if (pendingQueueRef.current.length === 0) return null;
        const nextIds = pendingQueueRef.current.splice(0, $6637ea4439045177$var$EXCERPT_BATCH_LIMIT);
        return {
            ids: nextIds,
            after: null
        };
    }, []);
    const batchResult = (0, $jMyy4.useQueryInterop)((0, $ffc2f0f2f9bab974$export$2e2bcd8739ae039), {
        variables: variables,
        skip: !showExcerpt || state.currentRequest === null,
        __callerPackage__: "@confluence/pagetree-macro"
    });
    // Post-fetch handler: merges the resolved page into `excerptMap` AND
    // advances the request pointer in a single `setState`. Combining both
    // updates in one call sidesteps the
    // `@atlassian/perf-linting/no-chain-state-updates` rule.
    (0, $42omo.useEffect)(()=>{
        const request = state.currentRequest;
        if (!request) return;
        if (batchResult.loading) return;
        // Recovery path: if the query failed (or resolved without data), advance
        // to the next queued chunk so we don't deadlock `currentRequest` forever.
        if (batchResult.error || !batchResult.data) {
            setState((prev)=>{
                if (prev.currentRequest !== request) return prev;
                return {
                    ...prev,
                    currentRequest: takeNextRequest()
                };
            });
            return;
        }
        const data = batchResult.data;
        if (data === processedDataRef.current) return;
        processedDataRef.current = data;
        const { nodes: nodes, pageInfo: pageInfo } = (0, $bEk7g.extractBatchPage)(data);
        const hasNextPage = !!pageInfo?.hasNextPage;
        const nextCursor = pageInfo?.endCursor ?? null;
        const canPaginate = hasNextPage && !!nextCursor && nextCursor !== request.after;
        let nextRequest;
        if (canPaginate) nextRequest = {
            ids: request.ids,
            after: nextCursor
        };
        else nextRequest = takeNextRequest();
        setState((prev)=>({
                excerptMap: nodes.length > 0 ? $6637ea4439045177$var$mergeBatchPage(prev.excerptMap, nodes) : prev.excerptMap,
                currentRequest: nextRequest
            }));
    }, [
        batchResult.data,
        batchResult.error,
        batchResult.loading,
        state.currentRequest,
        takeNextRequest
    ]);
    const enqueueExcerptIds = (0, $42omo.useCallback)((ids)=>{
        let added = false;
        for (const id of ids){
            if (!id || seenIdsRef.current.has(id)) continue;
            seenIdsRef.current.add(id);
            pendingQueueRef.current.push(id);
            added = true;
        }
        if (!added) return;
        // Only kick off a fresh request if the loader is currently idle.
        // Otherwise the in-flight chunk will pull from the queue when it
        // finishes.
        setState((prev)=>{
            if (prev.currentRequest !== null) return prev;
            const nextRequest = takeNextRequest();
            return nextRequest ? {
                ...prev,
                currentRequest: nextRequest
            } : prev;
        });
    }, [
        takeNextRequest
    ]);
    return {
        excerptMap: state.excerptMap,
        enqueueExcerptIds: enqueueExcerptIds
    };
};


const $f8be6b6784353e4e$var$useParsedMacroParams = (macroParams, defaultSpaceKey)=>{
    const parsedParams = (0, $bEk7g.parseMacroParams)(macroParams, defaultSpaceKey);
    const jsonParams = (0, $42omo.useMemo)(()=>(0, $bEk7g.serializeMacroParams)(parsedParams), [
        parsedParams
    ]);
    return {
        parsedParams: parsedParams,
        jsonParams: jsonParams
    };
};
const $f8be6b6784353e4e$var$styles = {
    controls: "_85i5u2gc",
    error: "_1yt4pxbi",
    searchInput: "_1bsbzdsj _2hwxu2gc _otyru2gc",
    linkButton: "_11c81d4k _1dqoglyw _1rjcze3t _18zrze3t _bfhk1j28 _syaz13af _80omtlke"
};
const $f8be6b6784353e4e$var$PageTreeMacroRendererComponent = ({ macroDefaultProps: macroDefaultProps, macroParams: macroParams, RendererWrapper: RendererWrapper })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { contentId: contentId, extensionKey: extensionKey, mode: mode, node: node } = macroDefaultProps;
    const attributes = macroDefaultProps.attributes ?? (0, $5kjCz.getMacroAttributesFromADFNode)(node);
    const experienceName = (0, $5kjCz.getExperienceName)(mode, node);
    const { parsedParams: parsedParams, jsonParams: jsonParams } = $f8be6b6784353e4e$var$useParsedMacroParams(macroParams, macroDefaultProps.spaceKey ?? '');
    const { rootParam: rootParam, spaceKey: spaceKey, showExcerpt: showExcerpt, sort: sort, reverse: reverse, showSearchBox: showSearchBox, showExpandCollapseAll: showExpandCollapseAll, startDepth: startDepth } = parsedParams;
    const isServer = (0, $e4o8D.useRenderServerPlaceholder)();
    const [searchQuery, setSearchQuery] = (0, $42omo.useState)('');
    const [expandAllCounter, setExpandAllCounter] = (0, $42omo.useState)(0);
    const [collapseAllCounter, setCollapseAllCounter] = (0, $42omo.useState)(0);
    let effectiveStartDepth = startDepth;
    if (expandAllCounter > 0) effectiveStartDepth = 999;
    else if (collapseAllCounter > 0) effectiveStartDepth = 0;
    const { nodes: nodes, ancestorIds: ancestorIds, loading: loading, error: error, rootResolved: rootResolved, rootId: rootId } = (0, $120689156450f914$export$b005fb2b94547bd6)({
        contentId: macroDefaultProps.contentId,
        rootParam: rootParam,
        spaceKey: spaceKey,
        sort: sort,
        reverse: reverse
    }); // Single-state excerpt cache + paginated batch loader. `excerptMap` is a
    // new reference on every batch resolution.
    // `enqueueExcerptIds` is a stable callback. The instrumentation
    // in `NestedAdfRendererWrapper` (when enabled) shows whether the
    // resulting downstream re-renders are cheap.
    const { excerptMap: excerptMap, enqueueExcerptIds: enqueueExcerptIds } = (0, $6637ea4439045177$export$33e885d6fee42b92)(showExcerpt); // Feed visible root IDs into the loader. Auto-expanded descendants are
    // enqueued by PageTreeNodeComponent when their auto-expand children
    // arrive.
    (0, $42omo.useEffect)(()=>{
        if (!showExcerpt || !nodes || nodes.length === 0) return;
        enqueueExcerptIds(nodes.map((n)=>n.id));
    }, [
        showExcerpt,
        nodes,
        enqueueExcerptIds
    ]);
    const handleExpandAll = (0, $42omo.useCallback)(()=>{
        setExpandAllCounter((prev)=>prev + 1);
        setCollapseAllCounter(0);
    }, []);
    const handleCollapseAll = (0, $42omo.useCallback)(()=>{
        setCollapseAllCounter((prev)=>prev + 1);
        setExpandAllCounter(0);
    }, []);
    const handleSearchChange = (event)=>{
        setSearchQuery(event.target.value);
    };
    const handleSearchSubmit = (0, $42omo.useCallback)(()=>{
        const trimmed = searchQuery.trim();
        if (!trimmed) return;
         // Scope the search to the resolved root via the "ancestor" param, matching
        // the legacy macro and the pagetree-search-macro pattern. `rootId` is the
        // current page for @self, the homepage for @home, the parent for @parent,
        // the matched page for a title root, and `undefined` for @none (no ancestor).
        // `spaceKey` is always set here — the component early-returns above when it
        // is missing — so it can be added unconditionally.
        const queryParams = {
            text: trimmed,
            spaces: spaceKey
        };
        if (rootId) queryParams.ancestor = rootId;
         // Browser-only navigation, guarded by the SSR placeholder hook (`isServer`)
        // per the Confluence SSR Must rule rather than a raw `typeof window` check.
        // The staged guard-browser-globals rule only recognises a literal `typeof
        // window` guard, so it is disabled for this line.
        if (!isServer) // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals -- guarded by useRenderServerPlaceholder (isServer) per SSR Must rule
        window.location.href = (0, $1NBp8.ADVANCED_SEARCH).toUrl({}, {
            query: queryParams
        });
    }, [
        searchQuery,
        spaceKey,
        rootId,
        isServer
    ]);
    if (!spaceKey) {
        const unsupportedContentError = new Error(formatMessage((0, $fb81ff3196c114be$export$a7357cdd1f0b0168).unsupportedContent));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $JbVPK.MacroExperienceFailure), {
            name: experienceName,
            contentId: contentId,
            extensionKey: extensionKey,
            mode: mode,
            attributes: attributes,
            error: unsupportedContentError
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $f8be6b6784353e4e$var$styles.error,
            testId: "pagetree-error-unsupported"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $fb81ff3196c114be$export$a7357cdd1f0b0168).unsupportedContent)));
    }
    if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        testId: "pagetree-loading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        alignBlock: "center",
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
        size: "medium"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, formatMessage((0, $fb81ff3196c114be$export$a7357cdd1f0b0168).loading))));
    if (error) {
        const pageTreeError = new Error(error);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $JbVPK.MacroExperienceFailure), {
            name: experienceName,
            contentId: contentId,
            extensionKey: extensionKey,
            mode: mode,
            attributes: attributes,
            error: pageTreeError
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: pageTreeError
        }));
    } // Only a genuinely unresolvable root (e.g. a title/@home/@parent root that
    // points at nothing) is a "not found" failure. A root that resolves but has
    // no children is a valid, empty tree — matching the legacy backend, which
    // renders an empty tree in that case rather than surfacing an error.
    if (!rootResolved) {
        const rootNotFoundError = new Error(formatMessage((0, $fb81ff3196c114be$export$a7357cdd1f0b0168).rootNotFound));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $JbVPK.MacroExperienceFailure), {
            name: experienceName,
            contentId: contentId,
            extensionKey: extensionKey,
            mode: mode,
            attributes: attributes,
            error: rootNotFoundError
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $f8be6b6784353e4e$var$styles.error,
            testId: "pagetree-error-root-not-found"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $fb81ff3196c114be$export$a7357cdd1f0b0168).rootNotFound)));
    } // Root resolved. `nodes` may still be empty (page has no children) — render
    // an empty tree and report success, rather than a failure.
    const treeNodes = nodes ?? [];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bX5uj.MacroExperienceSuccess), {
        name: experienceName,
        contentId: contentId,
        extensionKey: extensionKey,
        mode: mode,
        attributes: attributes
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        testId: "pagetree-macro",
        "data-fabric-macro": macroDefaultProps?.attributes?.macroId,
        "data-macro-body": "",
        "data-macro-parameters": jsonParams
    }, (showExpandCollapseAll || showSearchBox) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        xcss: $f8be6b6784353e4e$var$styles.controls
    }, showSearchBox && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fzqvY.default), {
        onSubmit: handleSearchSubmit
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $f8be6b6784353e4e$var$styles.searchInput
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4noo5.default), {
        value: searchQuery,
        onChange: handleSearchChange,
        testId: "pagetree-search",
        "aria-label": formatMessage((0, $fb81ff3196c114be$export$a7357cdd1f0b0168).searchPlaceholder)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        appearance: "default",
        type: "submit",
        testId: "pagetree-search-button"
    }, formatMessage((0, $fb81ff3196c114be$export$a7357cdd1f0b0168).searchButton)))), showExpandCollapseAll && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVUfS.default), {
        xcss: $f8be6b6784353e4e$var$styles.linkButton,
        onClick: handleExpandAll,
        testId: "pagetree-expand-all"
    }, formatMessage((0, $fb81ff3196c114be$export$a7357cdd1f0b0168).expandAll)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVUfS.default), {
        xcss: $f8be6b6784353e4e$var$styles.linkButton,
        onClick: handleCollapseAll,
        testId: "pagetree-collapse-all"
    }, formatMessage((0, $fb81ff3196c114be$export$a7357cdd1f0b0168).collapseAll)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        key: `${expandAllCounter}-${collapseAllCounter}`
    }, treeNodes.map((treeNode)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ea36937e8193af66$export$8f2e502782521c88), {
            key: treeNode.id,
            node: treeNode,
            showExcerpt: showExcerpt,
            startDepth: effectiveStartDepth,
            currentDepth: 0,
            currentPageId: macroDefaultProps.contentId,
            spaceKey: spaceKey,
            spaceId: macroDefaultProps.spaceId,
            sort: sort,
            reverse: reverse,
            ancestorIds: ancestorIds,
            RendererWrapper: RendererWrapper,
            excerptMap: excerptMap,
            enqueueExcerptIds: enqueueExcerptIds,
            loadedViaAutoExpand: true
        })))));
};
const $f8be6b6784353e4e$export$ba125f9672342d6d = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eCryJ.GenericErrorBoundary), {
        renderOnError: (_error)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $fb81ff3196c114be$export$a7357cdd1f0b0168).error);
        },
        attribution: (0, $3IBnw.Attribution).PAGE_EXTENSIONS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f8be6b6784353e4e$var$PageTreeMacroRendererComponent, props));
};
module.exports["PageTreeMacroRenderer"] = $f8be6b6784353e4e$export$ba125f9672342d6d;

});

parcelRegister("JbVPK", function(module, exports) {

var $2bAZx = parcelRequire("2bAZx");


var $5kjCz = parcelRequire("5kjCz");

function $98aa426b73cdcfeb$export$e394c7ce8301e00f({ attributes: attributes, children: children = null, contentId: contentId, extensionKey: extensionKey, error: error, mode: mode, name: name, source: source }) {
    (0, $2bAZx.useDeepCompareEffect)(()=>{
        (0, $5kjCz.getMacroExperienceTracker)(mode, contentId).fail({
            name: name,
            attributes: {
                ...attributes,
                source: source
            },
            error: error
        });
    }, [
        attributes,
        contentId,
        extensionKey,
        error,
        mode,
        name,
        source
    ]);
    return children;
}
module.exports["MacroExperienceFailure"] = $98aa426b73cdcfeb$export$e394c7ce8301e00f;

});


//# sourceMappingURL=PageTreeMacroRenderer.89d7bce4.js.map
